import React from "react";
import ButtonIn from "./offerbtn_in.svg";
import ButtonOut from "./offerbtn_out.svg";
import ButtonOffer from "./offerbtn_btn.svg";
import styles from "./offerbutton.module.scss";

type Props = {
  isUserLoggedIn: boolean;
  handler?: () => void;
};
const OfferButton: React.FC<Props> = (props) => {
  const { handler, isUserLoggedIn } = props;

  return (
    <>
      {isUserLoggedIn == true ? (
        <button type="button" onClick={handler} className={styles["offer-btn"]}>
          <div className={styles["offer-btn_out"]}>
            <img src={ButtonOut} />
          </div>
          <div className={styles["offer-btn_in"]}>
            <img src={ButtonIn} />
          </div>
          <div className={styles["offer-btn_logo"]}>
            <img src={ButtonOffer} />
          </div>
        </button>
      ) : (
        <span className={styles["offer-btn-sample"]}>
          <span className={styles["offer-btn-sample_span"]}>
            ※会員限定の機能です
          </span>
          <div className={styles["offer-btn"]}>
            <div className={styles["offer-btn_out"]}>
              <img src={ButtonOut} />
            </div>
            <div className={styles["offer-btn_in"]}>
              <img src={ButtonIn} />
            </div>
            <div className={styles["offer-btn_logo"]}>
              <img src={ButtonOffer} />
            </div>
          </div>
        </span>
      )}
    </>
  );
};

export default OfferButton;
